import { Typography } from "@mui/material";

export const ForgotPasswordTitle = () => {
  return (
    <Typography className={"text-3xl font-bold"}>Forgot password</Typography>
  );
};
